<template>
	<div class="social-login__form">
		<CCallout type="error">
			{{ authResult.OrganizationName }} has downgraded to the free Individual plan, which limits the number of users.<br />
			To have your access restored, please contact <a :href="'mailto:' + authResult.OwnerEmail">{{ authResult.OwnerName }}</a>.
		</CCallout>
		<CButton class="button button--primary sz-4" @click="handleLogout">Logout</CButton>
		<div v-if="authResult.ShowCreateOrganization" class="flex justify-center items-center">
			<RouterLink to="/signup/create">Create an Organization</RouterLink>
		</div>
	</div>
</template>

<script lang="ts">
	import type { PropType } from 'vue';
	import { defineComponent } from 'vue';
	import CCallout from '@cognitoforms/shared-components/src/components/content/Callout.vue';
	import CButton from '@cognitoforms/shared-components/src/components/interaction/Button.vue';
	import type { AccessLostResult } from '@cognitoforms/types/server-types/services/infrastructure/authentication/access-lost-result';
	import { logout } from '@cognitoforms/api/services/session-service';

	export default defineComponent({
		components: { CCallout, CButton },
		props: {
			authResult: {
				type: Object as PropType<AccessLostResult>,
				default: () => {}
			}
		},
		setup(props) {
			const handleLogout = async () => {
				await logout();
				window.location.assign('/');
			};

			return {
				handleLogout
			};
		}
	});
</script>